import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ContentIntelligenceSidebarSectionProps } from '../src/spaceSidebar/ContentIntelligenceSidebarSection.tsx';
import { ContentIntelligenceSidebarSectionPlaceholder } from '../src/spaceSidebar/ContentIntelligenceSidebarSectionPlaceholder.tsx';

/**
 * The Content Intelligence section of the space sidebar.
 *
 * `LoadableAfterPaint` because the sidebar renders on every space page and this section is not part
 * of what a page needs to paint. Until it loads, the placeholder renders the plain link it replaces.
 */
export const ContentIntelligenceSidebarSectionLoader: LoadableType<ContentIntelligenceSidebarSectionProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentIntelligenceSidebarSection" */ '../src/spaceSidebar/ContentIntelligenceSidebarSection.tsx'
				)
			).ContentIntelligenceSidebarSection,
		loading: ContentIntelligenceSidebarSectionPlaceholder,
	});
